import { defineStore } from "pinia";
import { ref } from "vue";

// import { v4 as uuidv4 } from 'uuid';

import { useSound } from "@/service/sound"



const defaultData = {
    duration: 3500,
    text: 'default message',
    type: 'info',
    title: 'default title',
    callbackOnShow: null,
    callbackOnHide: null,
    showUICountdown: false,
}

export const useToastsStore = defineStore('toastStore', () => {

    const soundService = useSound()

    const toastsBucket = ref([])


    const toast = (data) => {
        const toastData = { ...defaultData, ...data }
        toastData.uuid = crypto.randomUUID();
        
        if (ENVIRONMENT !== 'production') {
            console.log("📫 toast called with data", toastData)
        }

        toastsBucket.value.push(toastData)

        let soundToPlay = null

        switch (toastData.type) {
            case 'success':
                soundToPlay = "success"
                break
            case 'error':
                soundToPlay = "error"
                break
            case 'info':
                soundToPlay = "info"
                break
            case 'warning':
                soundToPlay = "warning"
                break
            default:
                soundToPlay = "info"
                break
        }

        if (toastData.sound) {
            soundToPlay = toastData.sound
        }

        if (toastData?.sound !== false) {
            soundService.play(soundToPlay)
        }


        // calling callback on show
        if (toastData?.callbackOnShow) {
            toastData.callbackOnShow()
        }


        if (!toastData.dismissByUser) {
            setTimeout(() => {
                // console.log("removing toast")
                deleteByUUID(toastData.uuid)
            }, toastData.duration)

        }
    }


    const deleteByUUID = (uuid) => {

        const found_toast = getByUUID(uuid)
        // calling callback on hide

        if (found_toast?.callbackOnHide) {
            found_toast.callbackOnHide()
        }

        toastsBucket.value = toastsBucket.value.filter((toast) => toast.uuid !== uuid)
    }
    const getByUUID = (uuid) => {
        return toastsBucket.value.find((toast) => toast.uuid === uuid)
    }

    return {
        toastsBucket,
        deleteByUUID,
        getByUUID,
        toast: toast,
    }
})
